import dateUtils from '@utils/dateUtils';

/**
 *
 * @param {*} data.itemsCommission
 * @returns { GST: 1, LP: 2 }
 */
const reducePartnerCommission = (items) => {
    return items.reduce((acc, item) => {
        const partner = item.partner.toLocaleUpperCase();

        acc[`partnerCommission${partner}`] = item.totalCommission;

        return acc;
    }, {});
};

export function normalizeItem(data) {
    return {
        id: data.id,
        partnerName: data.partnerName,
        partnerOrderId: data.partnerOrderId,
        date: dateUtils.parseDateString(data.date),
        productTicketCount: data.product.ticketCount,
        productTicketPrice: data.product.ticketPrice,
        productTicketType: data.product.ticketType,
        currency: data.currency,
        totalPrice: data.totalPrice,
        partnerCurrency: data.partnerCurrency,
        partnerOrderStatus: data.partnerOrderStatus,
        totalCommission: data.totalCommission,
        ...reducePartnerCommission(data.itemsCommission),
    };
}

export function normalizeTotalsItem(data) {
    return {
        id: `${data.partnerName}-${data.partnerOrderStatus}`,
        partnerName: data.partnerName,
        partnerOrderStatus: data.partnerOrderStatus,
        totalOrdersCount: data.totalOrderCount,
        totalTicketsCount: data.ticketCount,
        totalPrice: data.totalPrice,
        totalCommission: data.totalCommission,
        ...reducePartnerCommission(data.itemsCommission),
    };
}
